import { StoreTemplate } from "@/templates/TemplateLoader";
import { ReactNode } from "react";
import ContactElement from "@/templates/modern/elements/Contact";
import PageHeader from "../elements/PageHeader";

// default
import SectionContent from "@/templates/default/elements/SectionContent";

const elements = {
  ContactElement,
  SectionContent,
  PageHeader,
};

export function ContactPagesLoader(props: { children: ReactNode }) {
  StoreTemplate.load("modern", "contact", elements);
  return props.children;
}
